import { Directive, Host, Input, OnInit, TemplateRef } from '@angular/core';
import { NzSafeAny } from 'ng-zorro-antd/core/types/any';
import { EditableTemplateService } from './editable-template.service';

@Directive({
  selector: '[bixi-editable-col]'
})
export class EditableTemplateDirective implements OnInit {
  @Input('bixi-editable-col') tplName: string;  // 获取定义的列名

  constructor(private ref: TemplateRef<NzSafeAny>, @Host() private templateService: EditableTemplateService) {
  }

  ngOnInit() {
    this.templateService.add(this.tplName, this.ref);
  }
}
